import React from 'react'

import { compose, withHandlers } from 'recompose'
import styled from 'styled-components'

import withClickOutside from 'components/HOCs/withClickOutside'
import { style } from 'theme'

import AutocompletePrediction = google.maps.places.AutocompletePrediction

interface Props {
  onClickOutside: () => void
  onSelect: (suggestion: AutocompletePrediction) => void
  suggestions: AutocompletePrediction[]
}

interface HandlerProps {
  handleSuggestionClick: (event: React.MouseEvent) => void
}

type MergedProps = Props & HandlerProps

const enhance = compose<MergedProps, Props>(
  withHandlers<MergedProps, HandlerProps>({
    handleSuggestionClick:
      ({ onSelect, suggestions }) =>
      ({ target }: React.MouseEvent) => {
        onSelect(suggestions[(target as HTMLElement).dataset.index])
      },
  }),
  withClickOutside(({ onClickOutside }) => {
    onClickOutside(false)
  }),
)

const List = styled.ul`
  background-color: #fff;
  border-radius: 8px;
  box-shadow: ${style((theme) => theme.shadows.lgMedium)};
  left: 0;
  list-style: none;
  margin: -20px 0 0;
  max-height: 273px;
  overflow: scroll;
  padding: 0;
  position: absolute;
  width: 100%;
  z-index: 9999;

  li:not(:last-child) {
    border-bottom: 1px solid #f5f5f5;
  }
`

const ListItem = styled.li`
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 60px;
  padding: 0 20px;
  transition: opacity 200ms;

  &:hover {
    opacity: 0.7;
  }
`

const AutoCompleteList: React.ComponentClass<Props> = enhance(
  ({ handleSuggestionClick, suggestions }) => (
    <List>
      {suggestions.map((suggestion, index) => (
        <ListItem
          key={suggestion.place_id}
          onClick={handleSuggestionClick}
          data-index={index}
          tabIndex={0}
          role="listitem"
        >
          {suggestion.description}
        </ListItem>
      ))}
    </List>
  ),
)

export default AutoCompleteList
